<template>
  <div
    class="generic-header"
    :class="{ [`generic-header--${variant}`]: variant  }"
  >
    <div class="generic-header__title">
      <slot />
    </div>

    <div class="generic-header__side">
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: { type: String, default: '' }
  }
}
</script>

<style scoped lang="scss">
  .generic-header {
    $p: &;

    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ededed;
    border-radius: 5px;
    padding: 1.125rem 1.5625rem;
    border-bottom: 2px solid darken(#ededed, 5%);
    margin-bottom: 10px;

    &__title {
      font-family: 'Poppins';
      letter-spacing: .5px;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 15px;
      color: lighten(#000, 25%);
    }

    &--highlight {
      background: #ffa640;
      border-bottom: 2px solid darken(#ffa640, 5%);

      #{$p}__title { color: #fff }
    }
  } 
</style>